module.exports = __webpack_public_path__ + "images/feature/recycle-2-85cfb61f1eb03b9cba5c82afbee425f4.jpg";